<template>
    <el-dialog
        class="add-project-info"
        title="新增项目基础信息"
        :visible.sync="visible"
        width="525px"
        :before-close="befclose"
        :close-on-click-modal="false"
        append-to-body
    >
        <el-form
            ref="formId"
            :rules="rules"
            :model="formForUi"
            class="bm bm-ver form-info"
            label-position="left"
            size="small"
            label-width="110px"
        >
            <div class="bm bm-ver">
                <div>
                    <el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item
                                label="厂区"
                                style="width:100%"
                                prop="factoryCode"
                                :rules="{required: true, message: '请选择厂区',trigger: 'change'}"
                            >
                                <el-select
                                    style="width:100%"
                                    filterable
                                    placeholder="请选择"
                                    v-model="formForUi.factoryCode"
                                    clearable
                                    size="small"
                                    :disabled="!isShowZone"
                                >
                                    <el-option
                                        v-for="item in factoryList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item
                                label="工程项目名称"
                                style="width:100%"
                                prop="projectCode"
                                :rules="{required: true, message: '请选择工程项目',trigger: 'change'}"
                            >
                                <el-select
                                    style="width:100%"
                                    filterable
                                    @visible-change="v => visibleChange(v, 'projectSelect',clickSetUndefinedProjectName)"
                                    ref="projectSelect"
                                    v-model="formForUi.projectCode"
                                    clearable
                                    size="small"
                                    :disabled="!isShowZone"
                                    @change="selectProject"
                                >
                                    <!-- placeholder="请选择" -->
                                    <!-- <div slot="empty">
                                        <div class="bm bm-rev bm-pc">
                                            <span>
                                                未找到进行中的项目，点此
                                                <span>+制定未立项项目</span>
                                            </span>
                                        </div>
                                    </div>-->
                                    <el-option
                                        v-for="item in projectList"
                                        :key="item.projectCode"
                                        :label="item.projectName"
                                        :value="item.projectCode"
                                    >
                                        <span style="float: left">{{ item.projectName }}</span>
                                        <span
                                            v-if="item.projectCode.indexOf(UNDEFINED_PROJECT_CODE) != -1"
                                            style="float: right; color: #ffcc66; font-size: 13px"
                                        >未立项项目-未立项</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item
                                label="项目开始时间"
                                style="width:100%"
                                prop="projectStartDate"
                                :rules="{required: true, message: '请选择开始时间',trigger: 'change'}"
                            >
                                <el-date-picker
                                    style="width:100%"
                                    v-model="formForUi.projectStartDate"
                                    type="date"
                                    value-format="timestamp"
                                    placeholder="请选择开始时间"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item
                                label="项目结束时间"
                                style="width:100%"
                                prop="projectEndDate"
                                :rules="{required: true, message: '请选择结束时间',trigger: 'change'}"
                            >
                                <el-date-picker
                                    style="width:100%"
                                    v-model="formForUi.projectEndDate"
                                    type="date"
                                    value-format="timestamp"
                                    placeholder="请选择结束时间"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" class="bm bm-f1 bm-ac dept-info" v-if="isShowZone">
                        <el-col
                            :span="24"
                            class="bm bm-ps bm-ac futurePrice"
                            :class="isShowZone ? 'is-show-zone' : ''"
                        >
                            <el-form-item
                                label="功能区(楼栋)"
                                style="width:100%"
                               
                                
                            >
                            <!-- prop="projectClassify" :rules="{required: true, message: '请选择',trigger: 'change'}" -->
                                <div
                                    class="el-input el-input--small el-input--suffix"
                                    @click="handleProjectClassify"
                                    :class="isFocus ? 'is-focus' : ''"
                                >
                                    <el-input
                                        v-model="formForUi.projectClassify"
                                        size="small"
                                        clearable
                                        placeholder="请选择功能区(楼栋)"
                                        :disabled="true"
                                    ></el-input>
                                    <span class="el-input__suffix">
                                        <span class="el-input__suffix-inner">
                                            <i
                                                class="el-select__caret el-input__icon el-icon-arrow-up"
                                                :class="isFocus ? 'is-reverse' : ''"
                                            ></i>
                                        </span>
                                    </span>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="temporaryData(0)">取 消</el-button>
            <el-button type="primary" @click="temporaryData(1)">确 定</el-button>
        </div>

        <el-dialog
            width="525px"
            title="制定未立项项目"
            :visible.sync="innerDialogVisible"
            class="innerDialogStyle"
            append-to-body
            @closed="closedInner"
        >
            <el-form
                ref="innerDialogForm"
                :model="innerDialogFormModel"
                class="bm bm-ver form-info"
                size="small"
                label-width="135px"
            >
                <el-form-item
                    label="未立项项目名称"
                    style="width:100%"
                    prop="undefinedProjectName"
                    :rules="{required: true, message: '请输入',trigger: 'change'}"
                >
                    <el-input v-model="innerDialogFormModel.undefinedProjectName" placeholder="请输入"></el-input>
                </el-form-item>
                <div class="redText">您创建的未立项项目暂未正式立项，请后续继续在【项目管理平台】完成项目立项</div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="innerDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="clickSaveProjectName">保存</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>
<script>
// const R = require('ramda');
import { engineeringApi } from "@/services";
export default {
    props: {
        isShowZone: {
            type: Boolean,
            required: true,
            default: true
        },
        visible: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            default: "新增工程项目"
        },
        saveProjectFrom: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            //校验规则
            rules: {},
            isFocus: false,

            //制定未立项项目名称----START
            innerDialogVisible: false,
            innerDialogFormModel: {
                undefinedProjectName: ""
            },
            undefinedProjectNameCount: 1,
            UNDEFINED_PROJECT_CODE: "UNDEFINED_PROJECT_CODE",
            //制定未立项项目名称----END
            factoryList: this.$store.state.init.configInfo.factoryList,
            projectList: [
                //     {
                // 	"accessType": "",
                // 	"accessTypeDesc": "",
                // 	"aidType": "",
                // 	"aidTypeDesc": "",
                // 	"baseForm": "",
                // 	"baseFormDesc": "",
                // 	"commitDatetime": 1591062685000,
                // 	"completeDatetime": null,
                // 	"createDate": 1591062685000,
                // 	"createUserCode": "8104656",
                // 	"currentProgress": "",
                // 	"currentProgressDesc": "",
                // 	"customerName": "",
                // 	"departCode": "10001022",
                // 	"departName": "工程部",
                // 	"endDate": 1651248000000,
                // 	"goal": "",
                // 	"id": "20200602095125324003a2bf62c0eaee",
                // 	"isManager": "1",
                // 	"isParentProject": "1",
                // 	"managerCode": "8100715",
                // 	"managerName": "王律",
                // 	"parentProjectCode": "",
                // 	"passDatetime": null,
                // 	"productName": "",
                // 	"progress": 0,
                // 	"projectCode": "GC2020052200002",
                // 	"projectDesc": "",
                // 	"projectName": "南京顺欣新增生物车间3期 ",
                // 	"projectType": "engineer",
                // 	"researchType": "",
                // 	"researchTypeDesc": "",
                // 	"startDate": 1588262400000,
                // 	"status": "2",
                // 	"stopDatetime": null,
                // 	"subprojectList": [],
                // 	"subprojectNum": 1,
                // 	"updateDate": null,
                // 	"updateUserCode": ""
                // }
            ],
            formForUi: {
                factoryCode: "",
                factoryName: "",
                projectCode: "",
                projectName: "",
                projectClassify: "",
                projectStartDate: "",
                projectEndDate: "",
                departName: "",
                managerName: ""
            },
            //校验规则
            rules: {
                factoryCode: [
                    { required: true, message: "请选择厂区", trigger: "change" }
                ],
                projectCode: [
                    {
                        required: true,
                        message: "请选择工程项目",
                        trigger: "change"
                    }
                ],
                // projectClassify: [
                //     {
                //         required: true,
                //         message: "请选择功能区(楼栋)",
                //         trigger: "change"
                //     }
                // ],
                projectStartDate: [
                    {
                        required: true,
                        message: "请选择项目开始时间",
                        trigger: "change"
                    }
                ],
                projectEndDate: [
                    {
                        required: true,
                        message: "请选择项目结束时间",
                        trigger: "change"
                    }
                ]
            }
        };
    },
    mounted() {
        engineeringApi
            .projectListNew({
                userCode: this.$store.state.user.account,
                projectType: "engineer",
                pageSize: "10000",
                pageNo: "1"
            })
            .then(res => {
                if (res && res.msgCode == "100") {
                    if (res.responseData) {
                        this.projectList = res.responseData.list;
                    }
                }
            });
    },
    watch: {
        saveProjectFrom: {
            handler: function(newValue, oldValue) {
                let functionalAreaName = "";
                newValue.budget.map((item, index) => {
                    if (newValue.budget.length - 1 == index) {
                        functionalAreaName += item.functionalAreaName;
                    } else {
                        functionalAreaName += item.functionalAreaName + "/";
                    }
                });
                //初始化页面值
                this.formForUi = {
                    factoryCode: newValue.factoryCode,
                    factoryName: newValue.factoryName,
                    projectCode: newValue.project.projectCode,
                    projectName: newValue.project.projectName,
                    projectClassify: functionalAreaName,
                    projectStartDate: newValue.project.projectStartDate,
                    projectEndDate: newValue.project.projectEndDate,
                    managerName: newValue.project.projectManagerName,
                    departName: newValue.project.projectDepartName
                };
            },
            immediate: true,
            deep: true
        },
        visible: {
            handler: function(newValue, oldValue) {
                if (newValue) {
                    this.checkNullResetFieldsAndClearValidate("formId");
                    this.checkNullResetFieldsAndClearValidate(
                        "innerDialogForm"
                    );
                    let functionalAreaName = "";
                    console.log(this.saveProjectFrom);
                    if(this.saveProjectFrom){
                        this.saveProjectFrom.budget.map((item, index) => {
                            if (this.saveProjectFrom.budget.length - 1 == index) {
                                functionalAreaName += item.functionalAreaName;
                            } else {
                                functionalAreaName += item.functionalAreaName + "/";
                            }
                        });
                        //初始化页面值
                        this.formForUi = {
                            factoryCode: this.saveProjectFrom.factoryCode,
                            factoryName: this.saveProjectFrom.factoryName,
                            projectCode: this.saveProjectFrom.project.projectCode,
                            projectName: this.saveProjectFrom.project.projectName,
                            projectClassify: functionalAreaName,
                            projectStartDate: this.saveProjectFrom.project.projectStartDate,
                            projectEndDate: this.saveProjectFrom.project.projectEndDate,
                            managerName: this.saveProjectFrom.project.projectManagerName,
                            departName: this.saveProjectFrom.project.projectDepartName
                        };
                    }
                    
                }
            },
            immediate: true
        }
    },
    methods: {        
        closedInner() {
            this.innerDialogFormModel.undefinedProjectName = "";
        },
        //undefinedProjectName
        clickSetUndefinedProjectName() {
            if (
                this.$refs["innerDialogForm"] &&
                undefined != this.$refs["innerDialogForm"]
            ) {
                this.$refs["innerDialogForm"].clearValidate();
            }

            this.innerDialogVisible = true;
        },
        clickSaveProjectName() {
            this.$refs.innerDialogForm.validate(state => {
                if (state) {
                    let newItem = {
                        projectCode:
                            this.UNDEFINED_PROJECT_CODE +
                            this.undefinedProjectNameCount,
                        projectName: this.innerDialogFormModel
                            .undefinedProjectName,
                        startDate: "",
                        endDate: "",
                        managerName: "",
                        departName: ""
                    };
                    this.formForUi.projectName = newItem.projectName;
                    this.formForUi.projectCode = newItem.projectCode;
                    this.projectList.splice(0, 0, newItem);
                    this.innerDialogVisible = false;
                    this.undefinedProjectNameCount++;
                }
            });
        },
        /**
         * 为element-ui的Select和Cascader添加弹层底部操作按钮
         * @param visible
         * @param refName  设定的ref名称
         * @param onClick  底部操作按钮点击监听
         */
        visibleChange(visible, refName, onClick) {
            if (visible) {
                const ref = this.$refs[refName];
                let popper = ref.$refs.popper;
                if (popper.$el) popper = popper.$el;
                if (
                    !Array.from(popper.children).some(
                        v => v.className === "el-cascader-menu__list"
                    )
                ) {
                    const el = document.createElement("ul");
                    el.className = "el-cascader-menu__list";
                    el.style =
                        "border-top: solid 1px #E4E7ED; padding:0; color: #606266;";

                    // class="el-cascader-node"
                    el.innerHTML = `<li  style="height:38px;line-height: 38px">          
          <span class="el-cascader-node__label" style="font-family: MicrosoftYaHei;font-size: 12px;color: #323232;padding-left:20px">
                                                未找到进行中的项目，点此
                                                <span style="color: #3296fa;">+制定未立项项目</span>
                                            </span>
          </li>`;
                    popper.appendChild(el);
                    el.onclick = () => {
                        // 底部按钮的点击事件 点击后想触发的逻辑也可以直接写在这
                        onClick && onClick();

                        // 以下代码实现点击后弹层隐藏 不需要可以删掉
                        if (ref.toggleDropDownVisible) {
                            ref.toggleDropDownVisible(false);
                        } else {
                            ref.visible = false;
                        }
                    };
                }
            }
        },

        selectProject(value) {
            this.formForUi.projectName = "";
            this.formForUi.projectStartDate = "";
            this.formForUi.projectEndDate = "";

            let findItem = this.projectList.find(
                item => item.projectCode == value
            );
            if (findItem || findItem != undefined) {
                this.formForUi.projectName = findItem.projectName;
                this.formForUi.projectStartDate = findItem.startDate;
                this.formForUi.projectEndDate = findItem.endDate;
                this.formForUi.managerName = findItem.managerName;
                this.formForUi.departName = findItem.departName;
                if(findItem.projectCode !=this.UNDEFINED_PROJECT_CODE){
                    this.formForUi.managerList = findItem.managerList;
                    this.formForUi.departList = findItem.departList;
                }
               
            }
        },
        handleProjectClassify() {
            this.isFocus = true;
            this.saveProjectFrom.factoryCode = this.formForUi.factoryCode;
            this.saveProjectFrom.factoryName = this.formForUi.factoryCode
                ? R.find(R.propEq("id", this.formForUi.factoryCode))(
                      this.factoryList
                  ).name
                : "";

            this.saveProjectFrom.project.projectCode = this.formForUi.projectCode;
            this.saveProjectFrom.project.projectName = this.formForUi
                .projectCode
                ? R.find(R.propEq("projectCode", this.formForUi.projectCode))(
                      this.projectList
                  ).projectName
                : "";

            this.saveProjectFrom.project.projectStartDate = this.formForUi.projectStartDate;
            this.saveProjectFrom.project.projectEndDate = this.formForUi.projectEndDate;
            this.saveProjectFrom.project.projectManagerName = this.formForUi.managerName;
            this.saveProjectFrom.project.projectDepartName = this.formForUi.departName;
            let projectManagerList =[];
            this.formForUi.managerList&&this.formForUi.managerList.forEach(element => {
                projectManagerList.push({
                    projectManagerCode:element.managerCode,
                    projectManagerName:element.managerName,
                    projectId:element.projectId,
                })
            });
            this.saveProjectFrom.project.projectManagerList = projectManagerList;
            let projectDepartList =[];
            this.formForUi.departList &&this.formForUi.departList.forEach(element => {
                projectDepartList.push({
                    projectDepartName:element.departName,
                    projectDepartCode:element.departCode,
                    projectId:element.projectId,
                })
            });
            this.saveProjectFrom.project.projectDepartList = projectDepartList;
            this.$emit("handleChooseZone");
        },
        checkDept(rule, value, callback) {
            let info = "";
            if (R.isNil(value) || R.isEmpty(value) || value.length == 0) {
                info = "请选择部门";
                return callback(new Error(info));
            } else {
                return callback();
            }
        },
        temporaryData(e) {
            if (e == "1") {
                //点击确定
                this.$refs.formId.validate(state => {
                    if (state) {
                        this.saveProjectFrom.factoryCode = this.formForUi.factoryCode;
                        this.saveProjectFrom.factoryName = R.find(
                            R.propEq("id", this.formForUi.factoryCode)
                        )(this.factoryList).name;
                        // debugger
                        if (
                            this.formForUi.projectCode &&
                            this.formForUi.projectCode.indexOf(
                                this.UNDEFINED_PROJECT_CODE
                            ) != -1
                        ) {
                            //制定未立项项目名称没有projectCode
                            this.saveProjectFrom.project.projectCode = "";
                            this.saveProjectFrom.project.projectName = this.formForUi.projectName;
                            
                            // debugger
                        } else {
                            this.saveProjectFrom.project.projectCode = this.formForUi.projectCode;
                            this.saveProjectFrom.project.projectName = R.find(
                                R.propEq(
                                    "projectCode",
                                    this.formForUi.projectCode
                                )
                            )(this.projectList).projectName;
                            
                            let projectManagerList =[];
                         
                            this.formForUi.managerList&&this.formForUi.managerList.forEach(element => {
                                projectManagerList.push({
                                    projectManagerCode:element.managerCode,
                                    projectManagerName:element.managerName,
                                    projectId:element.projectId,
                                })
                            });
                            this.saveProjectFrom.project.projectManagerList = projectManagerList;
                        }
                        let projectDepartList =[];
                        this.formForUi.departList &&this.formForUi.departList.forEach(element => {
                            projectDepartList.push({
                                projectDepartName:element.departName,
                                projectDepartCode:element.departCode,
                                projectId:element.projectId,
                            })
                        });
                        this.saveProjectFrom.project.projectDepartList = projectDepartList;
                        this.saveProjectFrom.project.projectStartDate = this.formForUi.projectStartDate;
                        this.saveProjectFrom.project.projectEndDate = this.formForUi.projectEndDate;
                        this.saveProjectFrom.project.projectManagerName = this.formForUi.managerName;
                        this.saveProjectFrom.project.projectDepartName = this.formForUi.departName;
                        this.$emit("newProjectConfirm", this.formForUi);
                    }
                });
            } else {
                //点击取消
                this.$emit("newProjectCancel");
            }
        },
        checkNullResetFieldsAndClearValidate(filedName) {
            if (this.$refs[filedName] && this.$refs[filedName] != undefined) {
                this.$refs[filedName].resetFields();
                this.$refs[filedName].clearValidate();
            }
        },
        befclose() {
            this.$emit("newProjectCancel");
            this.undefinedProjectNameCount = 1;
            this.checkNullResetFieldsAndClearValidate("formId");
            this.checkNullResetFieldsAndClearValidate("innerDialogForm");
        },
        delProjectRow(e) {
            this.formForUi.list.splice(e, 1);
        }
    }
};
</script>
<style lang="scss" scoped>
.el-dialog__wrapper.add-project-info {
    .el-dialog__body {
        padding: 20px 20px;
        display: flex;
        align-items: center;
        overflow: auto;
        .form-info {
            height: 100%;
            width: 100%;
            .futurePrice {
                .el-select__caret {
                    color: #c0c4cc;
                    font-size: 14px;
                    -webkit-transition: -webkit-transform 0.3s;
                    transition: -webkit-transform 0.3s;
                    transition: transform 0.3s;
                    transition: transform 0.3s, -webkit-transform 0.3s;
                    -webkit-transform: rotateZ(180deg);
                    transform: rotateZ(180deg);
                    cursor: pointer;
                }
                .el-select__caret.is-reverse {
                    -webkit-transform: rotateZ(0deg);
                    transform: rotateZ(0deg);
                }
            }

            .dept-info {
                height: 45px;
                margin-bottom: 10px;
                .futurePrice {
                    position: relative;
                    .unit {
                        z-index: 100;
                        position: absolute;
                        top: 8px;
                        right: 40px;
                        font-size: 14px;
                        color: #969696;
                    }
                }
            }
            .project-list {
                .project-list-row {
                    margin-top: 30px;
                }
                .project-list-row:first-child {
                    margin-top: 0px;
                }
            }
            .project-title {
                margin-left: 20px;
                margin-bottom: 10px;
                font-size: 16px;
                line-height: 16px;
                color: #323232;
                .project-model {
                    font-size: 12px;
                    color: #969696;
                    margin-left: 9px;
                    line-height: 12px;
                }
            }
            .add-project {
                margin-left: 20px;
                margin-top: 20px;
                font-size: 14px;
                line-height: 14px;
                color: #409eff;
            }
            .project-info-row {
                border: solid 1px #dcdfe5;
                padding: 20px 20px 2px 20px;
                .price {
                    font-size: 14px;
                    line-height: 14px;
                    color: #ff3507;
                    margin-left: 30px;
                }
                .del-btn {
                    height: 50px;
                }
            }

            .el-input--small .el-input__inner {
                height: 36px;
                line-height: 36px;
            }
            .is-show-zone {
                /deep/.el-input.is-disabled .el-input__inner {
                    cursor: pointer;
                    background-color: #fff;
                }
            }
            .el-input-number__increase,
            .el-input-number__decrease {
                top: 2px;
                height: 28px;
            }
        }
    }
}
.innerDialogStyle {
    margin-top: 100px;
    .redText {
        font-family: MicrosoftYaHei;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 17px;
        letter-spacing: 1px;
        color: #ff0000;
    }
}
</style>
